/* global Sys, Services, Utils */
Sys.ns("Services");

/**
 * ### Free Rounds
 *
 * Provide functionality to handle Free Rounds from OSS.
 *
 */
Services.IntegrationFreeRounds = {

    /**
    * Initialize FreeRounds object.
    *
    * @param {Object} integration Integration module.
    *
    * @returns {this} FreeRounds object.
    */
    init: function(integration) {
        this._addListener = integration.addListener.bind(integration);
        this._removeListener = integration.removeListener.bind(integration);

        return this;
    },

    /**
     * Handles Free Round start.
     *
     * @returns {void}
     */
    handleFreeRoundsStart: function() {
        Services.freeRounds.acceptFreeRounds();
        Services.freeRounds.start();
        Services.freeRounds.confirmationResolved();
    },

    /**
     * Unblock game round.
     *
     * @returns {void}
     */
    unblockGameRound: function() {
        this._removeListener("notify:integrationBalanceId.reInit");

        Services.gameRound.removeStartBlocker();
    },

    /**
     * Handles Free Round end.
     *
     * @returns {void}
     */
    handleFreeRoundsEnd: function() {
        Services.gameRound.addStartBlocker();

        this._addListener("notify:integrationBalanceId.reInit", this.unblockGameRound.bind(this));

        Services.freeRounds.end();
    },

    /**
     * Handles dialog requet in Free Rounds.
     *
     * @param {string} dialogName Dialog name.
     *
     * @returns {void}
     */
    handleDialog: function(dialogName) {
        if (dialogName === Utils.CONSTANTS.DIALOG_NAMES.FREE_ROUNDS_START) {
            this.handleFreeRoundsStart();
        }
        else if (dialogName === Utils.CONSTANTS.DIALOG_NAMES.FREE_ROUNDS_END) {
            this.handleFreeRoundsEnd();
        }
    }
};
